import 'chart.js';
import 'hchs-vue-charts';
import Vue from 'vue';
// import VueGraph from 'vue-graph';
import Vuelidate from 'vuelidate';
import VueDragDrop from 'vue-drag-drop';
import format from 'date-fns/format';
import CKEditor from '@ckeditor/ckeditor5-vue2';
import VueAnalytics from 'vue-analytics';
import VueShortKey from 'vue-shortkey';
import VueTheMask from 'vue-the-mask';
import 'vue2-org-tree/dist/style.css';
import 'normalize.css';
import 'charts.css/dist/charts.min.css';
import store from '@/store';
import App from './App';
import registerVuetify from './vuetify';
import {
	httpRequestInterceptor,
	httpResponseInterceptor,
	httpResponseSuccessInterceptor,
} from './http/index';
import registerAxios from './axios';
import vueRouter from './router';
import globalMixin from './mixins/global';
import registerFilters from './filters/global';
import './global-components';
import helper from './shared/helper';

// Vue.use(window.VueCharts);
// Vue.use(VueGraph);
Vue.use(VueShortKey);
Vue.use(VueTheMask);
Vue.use(Vuelidate);
Vue.use(VueDragDrop);
Vue.use(CKEditor);
Vue.use(VueAnalytics, {
	id: 'UA-XXXXXXX-1',
	autoTracking: {
		screenview: true,
	},
	disableScriptLoader: true,
	sendHitTask: window.location.hostname === 'praktiko.netlify.com',
});

const userInfo = helper.getLocalData('praktiko-user');
const router = vueRouter(Vue);
registerFilters(Vue);
registerVuetify(Vue);
registerAxios(Vue);
Vue.prototype.$imageUrl = process.env.S3_IMAGES_URL;
Vue.prototype.$userInfo = userInfo;
Vue.config.productionTip = false;
Vue.prototype.$today = format(new Date(), 'YYYY-MM-DD');

Vue.mixin(globalMixin);

async function created() {
	const route = window.location.pathname;
	const surveyId = Number(route.split('/')[2]);
	Vue.prototype.$appColors = JSON.parse(process.env.COLORS);
	Vue.prototype.$userInfo = helper.getLocalData('praktiko-user');
	helper.setLocalData('surveyId', surveyId);
	this.$http.interceptors.request.use(this.httpRequestInterceptor);
	this.$http.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpAcl.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpAcl.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpPraktiko.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpPraktiko.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpUpLoad.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpUpLoad.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	this.$httpJobEvaluation.interceptors.request.use(this.httpRequestInterceptor);
	this.$httpJobEvaluation.interceptors.response.use(
		this.httpResponseSuccessInterceptor,
		this.httpResponseInterceptor,
	);
	const token = helper.getLocalToken();
	if (token) {
		const { data: response } = await this.$httpPraktiko.get('employee/current');
		helper.setLocalData('praktiko-user', response);
		helper.setLocalData('acl-code', response.aclCode);
		this.$store.dispatch('setUser', response);
		Vue.prototype.$userInfo = helper.getLocalData('praktiko-user');
	}
}

/* eslint-disable no-new */
new Vue({ // eslint-disable-line no-new
	created,
	el: '#app',
	methods: {
		httpRequestInterceptor,
		httpResponseInterceptor,
		httpResponseSuccessInterceptor,
	},
	router,
	render: h => h(App),
	store,
});



// WEBPACK FOOTER //
// ./src/main.js